











import { Component } from 'vue-property-decorator';

import { images } from '@/core/constants';
import AppVue from '@/AppVue.vue';

@Component
export default class AuthHeaderCpt extends AppVue {
  get whiteEiLogo() {
    return images.whiteEiLogo;
  }
}
